import { GraduationCap, Phone, Mail, MapPin, MessageCircle, Globe } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-dark text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-gold text-navy">
              <GraduationCap className="w-6 h-6" />
            </span>
            <span className="font-display font-extrabold text-lg">INVICTA <span className="text-gold">Overseas</span></span>
          </div>
          <p className="text-white/60 text-sm leading-relaxed">
            Your trusted partner for global education. Free & genuine guidance from settled professionals abroad.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-gold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="#destinations" className="hover:text-gold transition-colors">Destinations</a></li>
            <li><a href="#services" className="hover:text-gold transition-colors">Services</a></li>
            <li><a href="#why" className="hover:text-gold transition-colors">Why Choose Us</a></li>
            <li><a href="#enquiry" className="hover:text-gold transition-colors">Enquiry Form</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-gold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-gold shrink-0" /> Hyderabad, Telangana, India</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> {BRAND.phone}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> {BRAND.email}</li>
            <li className="flex items-center gap-2"><Globe className="w-4 h-4 text-gold" /> {BRAND.website}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-gold mb-4">Free Registration</h4>
          <p className="text-white/60 text-sm mb-4">WhatsApp your name & details to get started today.</p>
          <a
            href={`https://wa.me/${BRAND.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:brightness-110 text-white px-5 py-3 font-bold text-sm shadow-lg transition-all active:scale-95"
          >
            <MessageCircle className="w-5 h-5" /> {BRAND.whatsappDisplay}
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-10 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
        <p>© {new Date().getFullYear()} Invicta Overseas Educational Consultancy. All Rights Reserved.</p>
        <p>Study in USA · UK · Canada · Germany · Australia · Italy & 29+ countries</p>
      </div>
    </footer>
  );
}
